import { useState } from "react";
import { Box, Flex, HStack, Heading, Icon, SimpleGrid, Text } from "@chakra-ui/react";
import { FaBus, FaTruck, FaTrafficLight } from "react-icons/fa";
import InspectionOperationsScreen from "./fiscalization/InspectionOperationsScreen";
import BlitzInteligenteScreen from "./fiscalization/BlitzInteligenteScreen";

const INSPECTION_TYPES = [
  {
    id: "PUBLIC_TRANSPORT",
    title: "Transporte público",
    label: "Ônibus e vans",
    colorScheme: "teal",
    icon: FaBus,
    mode: "operations",
    categories: [
      { value: "ÔNIBUS", label: "Ônibus" },
      { value: "VAN", label: "Van" }
    ]
  },
  {
    id: "GARBAGE_COLLECTION",
    title: "Coleta de lixo",
    label: "Caminhões de lixo",
    colorScheme: "green",
    icon: FaTruck,
    mode: "operations",
    categories: [
      { value: "CAMINHÃO_LIXO", label: "Caminhão de lixo" }
    ]
  },
  {
    id: "SMART_BLITZ",
    title: "Blitz inteligente",
    label: "Consulta imediata de pendências por câmera",
    colorScheme: "orange",
    icon: FaTrafficLight,
    mode: "blitz"
  }
];

const Fiscalization = () => {
  const [selectedType, setSelectedType] = useState(null);

  if (!selectedType) {
    return (
      <Box p={6} flex="1" minH="100vh" bg="gray.100">
        <Heading size="lg" mb={1}>Fiscalização</Heading>
        <Text color="gray.600" mb={5}>Selecione o tipo de operação</Text>

        <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4} maxW="980px">
          {INSPECTION_TYPES.map((typeConfig) => (
            <Box
              as="button"
              key={typeConfig.id}
              textAlign="left"
              bg="white"
              borderWidth="1px"
              borderColor="gray.200"
              borderRadius="md"
              p={5}
              boxShadow="sm"
              transition="all 0.15s ease"
              _hover={{ borderColor: `${typeConfig.colorScheme}.400`, boxShadow: "md", transform: "translateY(-1px)" }}
              onClick={() => setSelectedType(typeConfig)}
            >
              <HStack spacing={4} align="center">
                <Flex boxSize="48px" borderRadius="md" bg={`${typeConfig.colorScheme}.50`} color={`${typeConfig.colorScheme}.600`} align="center" justify="center">
                  <Icon as={typeConfig.icon} boxSize={6} />
                </Flex>
                <Box>
                  <Heading size="md">{typeConfig.title}</Heading>
                  <Text color="gray.600" fontSize="sm" mt={1}>{typeConfig.label}</Text>
                </Box>
              </HStack>
            </Box>
          ))}
        </SimpleGrid>
      </Box>
    );
  }

  return (
    <Box p={6} flex="1" minH="100vh" bg="gray.100">
      {selectedType.mode === "operations" ? (
        <InspectionOperationsScreen
          selectedTypeConfig={selectedType}
          onBackToTypes={() => setSelectedType(null)}
        />
      ) : (
        <BlitzInteligenteScreen
          selectedTypeConfig={selectedType}
          onBackToTypes={() => setSelectedType(null)}
        />
      )}
    </Box>
  );
};

export default Fiscalization;
